import React, { Component } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Typography
} from '@material-ui/core';
import { Edit, Delete, Save, Cancel, BeachAccess } from '@material-ui/icons';
import EmployeeVacationsView from './EmployeeVacationsView';
import { getAllEmployeesUseCase } from '../services/getAllEmployeesUseCase';
import { updateEmployeeUseCase } from '../services/updateEmployeeUseCase';
import { addEmployeeUseCase } from '../services/addEmployeeUseCase';
import { deleteEmployeeUseCase } from '../services/deleteEmployeeUseCase';

class EmployeesDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employees: [],
            loading: true,
            editingId: null,
            editData: {},
            addingNew: false,
            newEmployee: {
                dni: '',
                name: '',
                password: '',
                position: ''
            },
            view: 'list', // 'list' or 'vacations'
            selectedEmployee: null
        };
    }

    handleViewVacations = (employee) => {
        this.setState({
            view: 'vacations',
            selectedEmployee: employee
        });
    }

    handleBackToList = () => {
        this.setState({
            view: 'list',
            selectedEmployee: null
        });
    }

    componentDidMount() {
        this.loadEmployees();
    }

    loadEmployees = async () => {
        this.setState({ loading: true });
        try {
            const employees = await getAllEmployeesUseCase();
            this.setState({ employees, loading: false });
        } catch (error) {
            console.error('Error loading employees:', error);
            this.setState({ loading: false });
        }
    }

    handleEdit = (employee) => {
        this.setState({
            editingId: employee.dni,
            editData: { ...employee }
        });
    }

    handleCancelEdit = () => {
        this.setState({
            editingId: null,
            editData: {}
        });
    }

    handleSaveEdit = async () => {
        const { editingId, editData } = this.state;
        try {
            await updateEmployeeUseCase(editingId, editData);
            this.setState({
                editingId: null,
                editData: {}
            });
            this.loadEmployees();
        } catch (error) {
            console.error('Error updating employee:', error);
            alert('Error al actualizar empleado');
        }
    }

    handleDelete = async (dni) => {
        if (window.confirm('¿Está seguro de eliminar este empleado?')) {
            try {
                await deleteEmployeeUseCase(dni);
                this.loadEmployees();
            } catch (error) {
                console.error('Error deleting employee:', error);
                alert('Error al eliminar empleado');
            }
        }
    }

    handleAddNew = () => {
        this.setState({ addingNew: true });
    }

    handleCancelAdd = () => {
        this.setState({
            addingNew: false,
            newEmployee: {
                dni: '',
                name: '',
                password: '',
                position: ''
            }
        });
    }

    handleSaveNew = async () => {
        const { newEmployee } = this.state;

        if (!newEmployee.dni || !newEmployee.name || !newEmployee.password) {
            alert('DNI, nombre y contraseña son obligatorios');
            return;
        }

        try {
            await addEmployeeUseCase(newEmployee);
            this.setState({
                addingNew: false,
                newEmployee: {
                    dni: '',
                    name: '',
                    password: '',
                    position: ''
                }
            });
            this.loadEmployees();
        } catch (error) {
            console.error('Error adding employee:', error);
            alert('Error al añadir empleado');
        }
    }

    handleEditChange = (field, value) => {
        this.setState({
            editData: {
                ...this.state.editData,
                [field]: value
            }
        });
    }

    handleNewChange = (field, value) => {
        this.setState({
            newEmployee: {
                ...this.state.newEmployee,
                [field]: value
            }
        });
    }

    render() {
        const { employees, loading, editingId, editData, addingNew, newEmployee, view, selectedEmployee } = this.state;

        if (view === 'vacations' && selectedEmployee) {
            return (
                <EmployeeVacationsView
                    employee={selectedEmployee}
                    onBack={this.handleBackToList}
                />
            );
        }

        return (
            <div>
                <div style={{ marginBottom: '16px', textAlign: 'right' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleAddNew}
                        disabled={addingNew}
                    >
                        Añadir Empleado
                    </Button>
                </div>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Paper style={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>DNI</strong></TableCell>
                                    <TableCell><strong>Nombre</strong></TableCell>
                                    <TableCell><strong>Contraseña</strong></TableCell>
                                    <TableCell><strong>Posición</strong></TableCell>
                                    <TableCell align="right"><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addingNew && (
                                    <TableRow style={{ backgroundColor: '#e3f2fd' }}>
                                        <TableCell>
                                            <TextField
                                                value={newEmployee.dni}
                                                onChange={(e) => this.handleNewChange('dni', e.target.value)}
                                                size="small"
                                                fullWidth
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newEmployee.name}
                                                onChange={(e) => this.handleNewChange('name', e.target.value)}
                                                size="small"
                                                fullWidth
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newEmployee.password}
                                                onChange={(e) => this.handleNewChange('password', e.target.value)}
                                                size="small"
                                                fullWidth
                                                type="password"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={newEmployee.position}
                                                onChange={(e) => this.handleNewChange('position', e.target.value)}
                                                size="small"
                                                fullWidth
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={this.handleSaveNew} color="primary" size="small">
                                                <Save />
                                            </IconButton>
                                            <IconButton onClick={this.handleCancelAdd} size="small">
                                                <Cancel />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {employees.map((employee) => (
                                    <TableRow key={employee.dni}>
                                        {editingId === employee.dni ? (
                                            <>
                                                <TableCell>
                                                    <TextField
                                                        value={editData.dni}
                                                        onChange={(e) => this.handleEditChange('dni', e.target.value)}
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        value={editData.name}
                                                        onChange={(e) => this.handleEditChange('name', e.target.value)}
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        value={editData.password}
                                                        onChange={(e) => this.handleEditChange('password', e.target.value)}
                                                        size="small"
                                                        fullWidth
                                                        type="password"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        value={editData.position}
                                                        onChange={(e) => this.handleEditChange('position', e.target.value)}
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton onClick={this.handleSaveEdit} color="primary" size="small">
                                                        <Save />
                                                    </IconButton>
                                                    <IconButton onClick={this.handleCancelEdit} size="small">
                                                        <Cancel />
                                                    </IconButton>
                                                </TableCell>
                                            </>
                                        ) : (
                                            <>
                                                <TableCell>{employee.dni}</TableCell>
                                                <TableCell>{employee.name}</TableCell>
                                                <TableCell>••••••••</TableCell>
                                                <TableCell>{employee.position || '-'}</TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        onClick={() => this.handleViewVacations(employee)}
                                                        color="primary"
                                                        size="small"
                                                        title="Ver Vacaciones"
                                                    >
                                                        <BeachAccess />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => this.handleEdit(employee)}
                                                        color="primary"
                                                        size="small"
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => this.handleDelete(employee.dni)}
                                                        color="secondary"
                                                        size="small"
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                ))}
                                {employees.length === 0 && !addingNew && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            <Typography color="textSecondary">
                                                No hay empleados registrados
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                )}
            </div>
        );
    }

}

export default EmployeesDialog;
